<template>
  <footer id="footer" class="footer">
    <div class="footer__pre">
      <div class="componata-container">
        Kontaktmöglichkeiten

        <ul class="footer__contact">
          <li><a href="tel:+49034198992080" v-on:click="trackPhone"><i class="icon icon-phone"></i> 0341 9899 2080</a></li>
          <li><a href="mailto:kundenservice@componata.de" v-on:click="trackMail"><i class="icon icon-envelope"></i> kundenservice@componata.de</a></li>
        </ul>
      </div>
    </div>

    <div class="footer__main">
      <div class="componata-container">
        <div class="footer__slot">
          <h3 class="footer__subtitle">Componata</h3>

          <ul class="footer__list">
            <li><router-link :to="cLink('/fertige')">Fertige Präsente</router-link></li>
            <li><router-link :to="cLink('/zusammenstellen')">Individuelle Präsente</router-link></li>
            <li><a href="https://componata.de/weihnachtspraesente-massgeschneidert-von-componata/">Weihnachten</a></li>
            <li><a href="/firmenkunden">Firmenkunden</a></li>
            <li><a href="/so-funktioniert-es-componata/">So funktionert es</a></li>
            <li><a href="/karriere/">Karriere</a></li>
          </ul>
        </div>

        <div class="footer__slot">
          <h3 class="footer__subtitle">Service</h3>

          <ul class="footer__list">
            <li><a href="/das-auspack-erlebnis-header/">Auspack-Erlebnis</a></li>
            <li><a href="/shop/">Shop: Delikatessen zum Nachbestellen</a></li>
            <li><a href="/versand__lieferung/">Versand & Lieferung</a></li>
            <li><a href="/allgemeine_geschaeftsbedingungen/">AGB</a></li>
            <li><a href="/widerruf/">Widerruf</a></li>
            <li><a href="/praesente/contact">Kontakt</a></li>
          </ul>
        </div>

        <div class="footer__slot">
          <h3 class="footer__subtitle">Zahlungsmöglichkeiten</h3>

          <div class="footer__payments">
            <img src="@/assets/images/icon-visa.svg" alt="Visa">
            <img src="@/assets/images/icon-mastercard.svg" alt="MaterCard">
            <img src="@/assets/images/icon-amex.svg" alt="AmericanExpress">
            <img src="@/assets/images/icon-paypal.svg" alt="PayPal">
            <img src="@/assets/images/icon-rechnung.svg" alt="Rechnung">
            <img src="@/assets/images/icon-sofort.svg" alt="Sofort">
          </div>
        </div>

        <div class="footer__slot">
          <h3 class="footer__subtitle">Versandpartner</h3>

          <div class="footer__shipping">
            <img src="@/assets/images/logo-dhl.svg" data-stretch="width" alt="DHL">
            <img src="@/assets/images/logo-ups.svg" data-stretch="height" alt="UPS">
            <img src="@/assets/images/logo-dpd.png" data-stretch="height" alt="DPD">
          </div>
        </div>
      </div>
    </div>

    <div class="footer__bottom">
      <div class="componata-container">
        <ul class="footer__other-links">
          <li><a href="/datenschutz/">Datenschutz</a></li>
          <li><a href="#" class="ch2-open-settings-bt" onclick="window.cookiehub.openSettings(); return false;">Cookie-Einstellungen</a></li>
          <li><a href="/impressum/">Impressum</a></li>
        </ul>

        <p class="footer__copyright">© Componata GmbH & Co. KG</p>
      </div>
    </div>
  </footer>
</template>

<script>
import { logicMixin } from '@/mixins/LogicMixin';

export default {
  name: 'TheFooter',
  mixins: [logicMixin],
  methods: {
    trackMail() {
      this.trackEvent('mailContactClicked');
    },
    trackPhone() {
      this.trackEvent('phoneContactClicked');
    },
    trackEvent(event) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: event,
        campaing: this.landingPageName
      });
    }
  }
};
</script>

<style lang="scss">
@import '../assets/styles/components/footer';
</style>
